// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1c7e57be","952":"8da05c44"}[chunkId] + ".chunk.js";
};